export default "\n{% block sw_context_menu_divider %}\n<hr class=\"sw_context_menu_divider\">\n{% endblock %}\n";